import { ref } from 'vue';
import { defineStore } from 'pinia';

export interface ThinkingTab {
    type: 'thinking' | 'tool';
    label: string;
    toolName?: string;
    content: string;
}

export type ThinkingStatus = 'idle' | 'thinking' | 'completed' | 'interrupted';

interface ChatMessage {
    role: 'user' | 'assistant';
    content: string;
    message_id?: string;
    reaction?: 'like' | 'dislike';
    responseStatus?: 'processing' | 'completed' | 'error';
    responseSeconds?: number;
    isPreset?: boolean;
    thinkingTabs?: ThinkingTab[];
    thinkingStatus?: ThinkingStatus;
    thinkingActiveTabIndex?: number;
    thinkingCollapsed?: boolean;
}

const useChatStore = defineStore('chat', () => {
    const messages = ref<ChatMessage[]>([]);

    function addMessage(msg: ChatMessage) {
        messages.value.push(msg);
    }

    function clearMessages() {
        messages.value = [];
    }

    return {
        messages,
        addMessage,
        clearMessages,
    };
});

export default useChatStore;
